import { useApp } from '@retainerclub/hooks';
import PropTypes from 'prop-types';
import {
  Card,
  RcLink,
  ShowStatus,
  ShowTableStandardRow,
} from '../../../shared';

function OrderShowProductionOrders({ order }) {
  const { isAdmin } = useApp();

  if (
    !(isAdmin && order.productionOrders) ||
    order.productionOrders.length === 0
  ) {
    return null;
  }

  function formatDate(dateString) {
    if (!dateString) {
      return 'N/A';
    }
    return new Date(dateString).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  }

  return (
    <Card
      className="p-4"
      heading="Production Orders"
      wrapperClassName="mb-4 mt-6"
    >
      <div className="mt-4 flow-root">
        <div className="overflow-x-auto ring-1 ring-black/10 sm:rounded-lg">
          <div className="inline-block min-w-full align-middle">
            <div className="overflow-hidden shadow sm:rounded-lg">
              <table className="min-w-full table-auto divide-y divide-black/20 text-sm">
                <thead className="bg-rcgray-200/80 font-normal text-black text-xs">
                  <tr className="divide-x divide-black/20 text-left">
                    <th scope="col" className="p-4">
                      Production ID
                    </th>
                    <th scope="col" className="p-4">
                      Created
                    </th>
                    <th scope="col" className="p-4">
                      State
                    </th>
                    <th scope="col" className="p-4">
                      Items
                    </th>
                    <th scope="col" className="p-4">
                      Tracking
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-black/20">
                  {order.productionOrders.map((productionOrder) => (
                    <ShowTableStandardRow key={productionOrder.id}>
                      <td className="max-w-0 p-4 uppercase">
                        <RcLink
                          to={`/production-orders/${productionOrder.id}`}
                          className="text-rcprimary-600 hover:text-rcprimary-800 hover:underline"
                        >
                          {productionOrder.hexCode}
                        </RcLink>
                      </td>
                      <td className="p-4">
                        {formatDate(productionOrder.createdAt)}
                      </td>
                      <td className="p-4">
                        <ShowStatus state={productionOrder.state} />
                      </td>
                      <td className="p-4">
                        {productionOrder.productionOrderItems?.length || 0}
                      </td>
                      <td className="p-4">
                        {productionOrder.productionOrderItems?.some(
                          (item) => item.trackingNumber,
                        )
                          ? 'Yes'
                          : 'No'}
                      </td>
                    </ShowTableStandardRow>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </Card>
  );
}

OrderShowProductionOrders.propTypes = {
  order: PropTypes.object.isRequired,
};

export default OrderShowProductionOrders;
